module.exports = __webpack_public_path__ + "media/sabrina.7bd20ef3.mp4";